/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbApprenantHistoryGridDto
 */
export interface FcbApprenantHistoryGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbApprenantHistoryGridDto
     */
    idappenantHistory?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbApprenantHistoryGridDto
     */
    iduser?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbApprenantHistoryGridDto
     */
    idpersonne?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbApprenantHistoryGridDto
     */
    idapprenant?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantHistoryGridDto
     */
    action?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantHistoryGridDto
     */
    actionType?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbApprenantHistoryGridDto
     */
    actionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantHistoryGridDto
     */
    userName?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FcbApprenantHistoryGridDto
     */
    ifapmeSide?: Array<string> | null;
}

/**
 * Check if a given object implements the FcbApprenantHistoryGridDto interface.
 */
export function instanceOfFcbApprenantHistoryGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbApprenantHistoryGridDtoFromJSON(json: any): FcbApprenantHistoryGridDto {
    return FcbApprenantHistoryGridDtoFromJSONTyped(json, false);
}

export function FcbApprenantHistoryGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbApprenantHistoryGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idappenantHistory': !exists(json, 'idappenantHistory') ? undefined : json['idappenantHistory'],
        'iduser': !exists(json, 'iduser') ? undefined : json['iduser'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'action': !exists(json, 'action') ? undefined : json['action'],
        'actionType': !exists(json, 'actionType') ? undefined : json['actionType'],
        'actionDate': !exists(json, 'actionDate') ? undefined : (new Date(json['actionDate'])),
        'userName': !exists(json, 'userName') ? undefined : json['userName'],
        'ifapmeSide': !exists(json, 'ifapmeSide') ? undefined : json['ifapmeSide'],
    };
}

export function FcbApprenantHistoryGridDtoToJSON(value?: FcbApprenantHistoryGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idappenantHistory': value.idappenantHistory,
        'iduser': value.iduser,
        'idpersonne': value.idpersonne,
        'idapprenant': value.idapprenant,
        'action': value.action,
        'actionType': value.actionType,
        'actionDate': value.actionDate === undefined ? undefined : (value.actionDate.toISOString()),
        'userName': value.userName,
        'ifapmeSide': value.ifapmeSide,
    };
}

